export default "__VITE_ASSET__ywRodUN7CSjibXRchOULSw__"